import React from 'react';
import sections from './graphs/CreditScoreGraph/sections';

const Statistic = props => {
  const { value, description, isNegative = false, ratingClass = false, blur = false } = props;
  return (
    <div className="ant-statistic ant-statistic-sm ">
      <div className="ant-statistic-content">
        <span
          className="ant-statistic-content-value"
          style={{
            background: !blur && sections.find(section => section.score === ratingClass)?.tooltipBorder,
            color: !blur && sections.find(section => section.score === ratingClass)?.textColor,
            borderRadius: 5,
            padding: value ? '5px 10px' : 0,
          }}
        >
          <span className={`ant-statistic-content-value-int${isNegative ? ' color-error' : ''}`}>{value}</span>
        </span>
      </div>
      <div className="ant-statistic-title">{description}</div>
    </div>
  );
};

export default Statistic;
